<div class="bg-inicio bg-sede" [className]="'bg-inicio bg-sede bg-sede-'+currSede">
  <div class="contenedor-textos-inicio">
    <div class="identificacion_jornada">{{ textoJornada }},</div>
    <h4 class="nombre_usuario">{{ user?.nombre }} {{ user?.apellidoPaterno }}</h4>
    <h3 class="mt-3 mb-3">{{ currHour }}</h3>
    <div class="backoffice text-center mb-2">BACKOFFICE</div>
    <h1 class="mt-1 text-uppercase">Portal de calificaciones</h1>
    <div class="hr-horizontal mx-auto"></div>
  </div>
</div>